export const theme = {
  white: "#ffffff",
  primary: "#F28F04",
  dark: "#252525",
  dark2: "#212121",
  notes: "hsl(49, 100%, 58%)",
  twitters: "hsl(196, 83%, 75%)",
  articles: "hsl(106, 47%, 64%)",
  grey100: "hsl(0, 0%, 96%)",
  grey200: "hsl(0, 0%, 90%)",
  grey300: "hsl(0, 0%, 82%)",
  fontSize: {
    xxs: "1rem",
    xs: "1.2rem",
    s: "1.6rem",
    m: "2.1rem",
    l: "2.4rem",
    xl: "4rem",
    xxl: "4.6rem",
  },
  breakpoints: {
    xs: "480px",
    sm: "768px",
    md: "992px",
    lg: "1200px",
    xl: "1400px",
  },
}
